/* ============================================
   VESTIMENTA MADRID - Theme JavaScript
   ============================================ */
 
document.addEventListener('DOMContentLoaded', function() {
 
  // HEADER SCROLL
  var header = document.querySelector('.vm-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 40);
    });
  }
 
  // MOBILE MENU
  var burger = document.querySelector('.vm-header__burger');
  var mobileMenu = document.querySelector('.vm-mobile-menu');
  var mobileClose = document.querySelector('.vm-mobile-menu__close');
 
  if (burger && mobileMenu) {
    burger.addEventListener('click', function() {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileClose) {
    mobileClose.addEventListener('click', function() {
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    });
  }
 
  // CART TRIGGER
  document.querySelectorAll('[data-cart-trigger], #vm-cart-trigger').forEach(function(t) {
    t.addEventListener('click', function(e) {
      e.preventDefault();
      if (typeof vmOpenCart === 'function') vmOpenCart();
    });
  });
  document.querySelectorAll('[data-cart-close], #vm-cart-close, .vm-cart-drawer__close-btn').forEach(function(t) {
    t.addEventListener('click', function() {
      if (typeof vmCloseCart === 'function') vmCloseCart();
    });
  });
 
  // PRODUCT PAGE ATC
  var productForm = document.getElementById('vm-product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantSelect = document.getElementById('vm-variant-select');
      var variantId = variantSelect ? variantSelect.value : null;
      if (!variantId) return;
      var btn = document.getElementById('vm-atc-btn');
      var originalText = btn ? btn.textContent : 'Add to Cart';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
 
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(r) {
        if (!r.ok) throw new Error('Failed');
        return r.json();
      })
      .then(function() {
        if (typeof vmRefreshCart === 'function') vmRefreshCart();
        if (btn) {
          btn.textContent = 'Added!';
          setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 2000);
        }
        setTimeout(function() {
          if (typeof vmOpenCart === 'function') vmOpenCart();
        }, 300);
      })
      .catch(function(err) {
        console.error('ATC error:', err);
        alert('Could not add to cart. Please try again.');
        if (btn) { btn.textContent = originalText; btn.disabled = false; }
      });
    });
  }
 
  // PRODUCT ACCORDION
  document.querySelectorAll('.vm-accordion__trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var item = trigger.closest('.vm-accordion__item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.vm-accordion__item').forEach(function(i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });
 
  // SIZE SELECTOR
  document.querySelectorAll('.vm-size-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (btn.classList.contains('sold-out')) return;
      var group = btn.closest('.vm-product__sizes');
      if (group) group.querySelectorAll('.vm-size-btn').forEach(function(b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
    });
  });
 
  // PRODUCT IMAGE GALLERY
  var mainImg = document.querySelector('.vm-product__main-img');
  document.querySelectorAll('.vm-product__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      document.querySelectorAll('.vm-product__thumb').forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg && thumb.dataset.full) mainImg.src = thumb.dataset.full;
    });
  });
 
  // SCROLL ANIMATIONS
  var animateEls = document.querySelectorAll('[data-animate]');
  if (animateEls.length && window.IntersectionObserver) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function() { entry.target.classList.add('visible'); }, i * 80);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    animateEls.forEach(function(el) { obs.observe(el); });
  }
 
  // COLLECTION FILTER
  document.querySelectorAll('.vm-filter-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.vm-filter-btn').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });
 
  // ESCAPE KEY
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (typeof vmCloseCart === 'function') vmCloseCart();
      var mm = document.querySelector('.vm-mobile-menu');
      if (mm) mm.classList.remove('open');
      document.body.style.overflow = '';
    }
  });
 
});
 